import { useAppContext } from 'hooks';
import { useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { RiskFlowControl } from 'types/RiskControl';

export const useFunctions = () => {
  const context = useAppContext();
  const outletContext = useOutletContext<RiskFlowControl>();
  const { riskFlow, setRiskFlow } = outletContext;
  const [triedSubmit, setTriedSubmit] = useState<boolean>(false);
  const [checkedState, setCheckedState] = useState<Record<number, boolean>>({
    0: false,
    1: false,
    2: false,
  });

  const errorVerifier = () => Object.values(checkedState).includes(false);

  const hasError = useMemo(
    () => triedSubmit && errorVerifier(),
    [checkedState, triedSubmit]
  );

  const handleCheck = (index: number) => {
    setCheckedState((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const handleCancel = () => {
    setRiskFlow({
      ...riskFlow,
      riskProcessed: true,
      hadSuccess: undefined,
    });
  };

  const handleNextStep = () => {
    const { steps } = context.state;

    if (errorVerifier()) {
      setTriedSubmit(true);
      return;
    }

    context.dispatch({
      type: 'update_step',
      payload: { currentStep: steps.currentStep + 1 },
    });
  };

  return { handleCheck, handleCancel, handleNextStep, hasError, checkedState };
};
